import React, {useState} from "react";
import arrowIcon from "../../../assets/icons/commons/arrow.svg";
import arrowIconReversed from "../../../assets/icons/commons/arrowReversed.svg";

const FilterProductsShipment: React.FC = () => {
    const [filtersOpen, setFiltersOpen] = useState(true);

    const toggleOpenSettings = () => {
        setFiltersOpen(!filtersOpen);
    };

    return (
        <div
            className={
                `bg-white rounded-sm border w-full 
              ${filtersOpen ? 'md:w-[20%]' : 'md:w-[4%]'} 
              ${filtersOpen ? 'min-w-[236px]' : 'min-w-[55px]'} 
              border-gray-200 transition-all flex flex-col justify-between pb-[14px]`
            }
        >

            <div>
                <div
                    onClick={toggleOpenSettings}
                    className={`bg-white h-[40px] px-4 flex items-center cursor-pointer ${
                        filtersOpen ? 'justify-between' : 'justify-center'
                    }`}
                >
                    <div className="flex items-center">
                        <button className="relative outline-none mr-4">
                            <img src={filtersOpen ? arrowIcon : arrowIconReversed} alt=""/>
                        </button>
                        {filtersOpen && (
                            <div className="text-[#94A3B8] font-semibold">ФИЛЬТРЫ</div>
                        )}
                    </div>
                </div>
                <hr/>
                <div>
                    <div className="relative">

                    </div>
                </div>
            </div>
        </div>
    )
}

export default FilterProductsShipment;